var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-popover',{attrs:{"placement":"top-start","trigger":"click"}},[_c('span',{class:_vm.icon + ' curp',attrs:{"slot":"reference"},slot:"reference"}),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }